/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorRichTextBox as ResolvedLabradorRichTextBox } from 'base/components/labrador/RichTextBox';

export const LabradorRichTextBox: typeof ResolvedLabradorRichTextBox = withLabradorInstanceof((props) => {
    return <ResolvedLabradorRichTextBox {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorRichTextBoxProps = PropsFromComponent<typeof LabradorRichTextBox>;
